import { IconButton, Paper, Typography } from "@material-ui/core";
import clsx from "clsx";
import { advancedFilterStyles } from "./AdvancedFiltersStyles";
import { ReactComponent as CloseIcon } from "icons/CloseIcon.svg";
import { LynxDropdown } from "components/LynxDropdown/LynxDropdown";
import { LynxButton } from "components/LynxButton/LynxButton";
import { observer } from "mobx-react";
import { useStore } from "store/StoreConfigs";

interface AdvancedFiltersProps {
    requestCallback: () => void;
}
export default observer(function AdvancedFilter(props: AdvancedFiltersProps) {
    const classes = advancedFilterStyles();
    const { filtersStore, commonStore } = useStore();
    const options = [
        {
            names: filtersStore.riskLevels,
            title: "Select a risk level",
            label: "Risk Level",
            state: filtersStore.selectRiskLevels,
            method: filtersStore.setSelectedRiskLevels,
        },
        {
            names: filtersStore.displayedProductTypes,
            title: "Select one or more product types",
            label: "Product Type",
            state: filtersStore.displayedSelectedProductTypes,
            method: filtersStore.setSelectedProductTypes,
        },
        {
            names: filtersStore.logisticsServiceProviders,
            title: "Select one or more LSPs",
            label: "Logistics Service Providers",
            state: filtersStore.selectedLogisticsServiceProviders,
            method: filtersStore.setSelectedLogisticsServiceProviders,
        },
        {
            names: filtersStore.packagingTypes,
            title: "Select one or more categories",
            label: "Packaging Type",
            state: filtersStore.selectedPackagingTypes,
            method: filtersStore.setSelectedPackagingTypes,
        },
        {
            names: filtersStore.modesOfTransportation,
            title: "Select one or more categories",
            label: "Modes of Transportation",
            state: filtersStore.selectedModesOfTransportation,
            method: filtersStore.setSelectedModesOfTransportation,
        },
    ];

    const handleFilterClose = () => {
        commonStore.setFiltersClose();
    };

    return (
        <div
            className={clsx({
                [classes.container]: commonStore.isFilterOpen,
            })}
        >
            <div></div>
            <Paper
                elevation={0}
                className={clsx(classes.filters, {
                    [classes.openFilter]: commonStore.isFilterOpen,
                    [classes.closeFilter]: !commonStore.isFilterOpen,
                })}
            >
                <Typography variant="h5" className={classes.title}>
                    Advanced Filters
                    <IconButton
                        className={classes.icon}
                        onClick={handleFilterClose}
                    >
                        <CloseIcon />
                    </IconButton>
                </Typography>
                {options.map((option, index) => (
                    <LynxDropdown
                        isCustomizable={false}
                        key={index}
                        options={option.names}
                        title={option.title}
                        label={option.label}
                        optionState={option.state}
                        stateSetMethod={option.method}
                        customClass={classes.customClass}
                    ></LynxDropdown>
                ))}

                <LynxButton
                    className={classes.resetButton}
                    onClick={filtersStore.resetFilters}
                    size="medium"
                >
                    Reset Filters
                </LynxButton>
                <LynxButton
                    className={classes.applyButton}
                    onClick={props.requestCallback}
                    size="medium"
                >
                    Apply Filters
                </LynxButton>
            </Paper>
        </div>
    );
});
